import storeHelper from '@/store/helper'
import { BaseService } from './base.service'
import { ErrorWrapper, ResponseWrapper } from './util'
import { TOKEN_INSIDE } from '../.env'
import axios from 'axios'

export class ContractService extends BaseService {
  static async fetch (params) {
    try {
      const response = await axios.post(storeHelper.getUrl('cnps.scon.contract.get-list-contract-web-agency'), params, {
        headers: {
          Authorization: 'Bearer ' + TOKEN_INSIDE
        }
      })
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }
  
  static async get (contractId) {
    try {
      const response = await axios.post(storeHelper.getUrl('cnps.scon.contract.get-detail-contract-web'), { contractId }, {
        headers: {
          Authorization: 'Bearer ' + TOKEN_INSIDE
        }
      })
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }
}
